<div class="form-group">
  <label class="control-label col-sm-3">
    {{ 'Category' | translate }}:
  </label>
  <label class="control-label col-sm-9">
    {{category.name}}
  </label>
</div>
<div class="form-group">
  <label class="control-label col-sm-3">
    {{ 'Service' | translate }}:
  </label>
  <label *ngIf="service" class="control-label col-sm-9">
    {{service.name}}
  </label>
</div>
<div class="form-group">
  <label class="control-label col-sm-3">
    {{ 'Provider' | translate }}:
  </label>
  <div class="col-sm-12" [ngClass]="'select-providers'">
    <div class="table-responsive" style="clear: both;">
      <table class="table table-hover" aria-label="distancetable">
        <thead style="background:#f9f9f9">
          <tr>
            <th scope="col">
              {{ 'Distance' | translate }}
            </th>
            <th scope="col">
              {{ 'Name' | translate }}
            </th>
            <th scope="col">
              {{ 'Provider Site' }}
            </th>
            <th scope="col">
              {{ 'Plane' }}
            </th>
             <th scope="col">
              {{ 'Contact' | translate }}
            </th>
            <th scope="col">
              {{ 'Phone' | translate }}
            </th>
            <th scope="col">
              {{ 'Price' | translate }}
            </th>
            <!-- <th>
              {{ 'Vehicle Size' | translate }}
            </th> -->
          </tr>
        </thead>
        <tbody>
          <tr>
            <td *ngIf="provider.distance">
              {{provider.distance}} {{'Km'}}
            </td>
            <td *ngIf="!provider.distance"></td>
            <td>{{provider.provider?.name}}</td>
            <td>{{ provider.provider_site?.equivalence_id }} - {{ provider.provider_site?.name }}</td>
            <td>
              <span *ngIf="provider.coverage?.coverage_type == 1">
                Plano {{ provider.coverage?.plane }}
              </span>
              <span *ngIf="provider.coverage?.coverage_type == 2">
                Foráneo
              </span>
            </td>
            <td>
              {{provider.provider?.contact_name}}
            </td>
            <td>
              <table aria-label="contactphonetable">
                <th scope="col"></th>
                <tbody>
                  <tr *ngFor="let contactPhone of getContactPhones(provider.provider?.contact_phones)">
                    <td>
                      {{ contactPhone }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
            <td *ngIf="provider?.provider?.price">
              {{provider.provider?.price | number: "1.2-2"}}
            </td>
            <td *ngIf="!provider?.provider?.price">
              N/A
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<div *ngIf="activeIndex == 2" class="form-group">
  <label class="control-label col-sm-3">
    {{ 'Contact Name' | translate }}:
  </label>
  <label class="control-label col-sm-9">
    {{assistancecase.contact_name}}
  </label>
</div>
<div *ngIf="activeIndex == 2" class="form-group">
  <label class="control-label col-sm-3">
    {{ 'Contact Phone' | translate }}:
  </label>
  <label class="control-label col-sm-9">
    {{assistancecase.phone}}
  </label>
</div>
